import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import React, { useState } from 'react'
import RoomOfferListTable from '../RoomOfferListTable'
import FormSelect from 'Common/Custom/FormSelect'

const AssignRoomOfferList = () => {
    const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
    const currentYear = new Date().getFullYear();
    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);

    const monthOptions = [
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
    ];
    
    const yearOptions = [];
    for (let i = currentYear - 1; i <= currentYear + 1; i++) {
        yearOptions.push({ value: String(i), label: String(i) });
    }

    return (
        <div className={`px-xl-5 px-lg-4 px-3 py-3 page-body`}>
            <div className="row g-3">
                <div className="col-12">
                    <div className="row g-2 align-items-center justify-content-lg-between">
                        <div className="col-lg-4">
                            <HeadingOne>Assign Room Offer</HeadingOne>
                        </div>
                        <div className="col-lg-8">
                            <div className="row g-2 justify-content-lg-end align-items-center mt-sm-0 mt-2">
                                <FormSelect
                                    value={month}
                                    handleChange={(e) => { setMonth(e.target.value); }}
                                    options={monthOptions}
                                    className="text-capitalize"
                                    placeholder="Select Month"
                                    aria-label="Select Month"
                                    field={{
                                        label: "",
                                        labClass: 'd-none',
                                        required: false,
                                        name: "month",
                                        fieldSize: "col-xxl-2 col-sm-4 col-6"
                                    }}
                                />
                                <FormSelect
                                    value={year}
                                    handleChange={(e) => { setYear(e.target.value); }}
                                    options={yearOptions}
                                    className="text-capitalize"
                                    placeholder="Select Year"
                                    aria-label="Select Year"
                                    field={{
                                        label: "",
                                        labClass: 'd-none',
                                        required: false,
                                        name: "year",
                                        fieldSize: "col-xxl-2 col-sm-4 col-6"
                                    }}
                                />
                                <div className="col-auto">
                                    <AddItemBtn url="assign-offer" title="Assign Room Offer" twoUrl={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="card">
                        <div className={`card-body`}>
                            <div className="row g-3">
                                <div className="col-12">
                                    <RoomOfferListTable
                                        month={month}
                                        year={year}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AssignRoomOfferList